import React from 'react'
import PropTypes from 'prop-types'
import Gold from '../Gold/Gold'
import Silver from '../Silver/Silver'
import EventCoin from '../EventCoin/EventCoin'
import CurrencyBase from '../CurrencyBase/CurrencyBase'
import Bons from '../Bons/Bons'

const CURRENCY_TYPES = {
    GOLD: 'gold',
    SILVER: 'credits',
    BONS: 'crystal',
    EVENT_COIN: 'event_coin',
}

class Currency extends React.PureComponent {
    static propTypes = {
        ...CurrencyBase.propTypes,
        type: PropTypes.oneOf(Object.values(CURRENCY_TYPES)).isRequired,
    }

    static defaultProps = {
        ...CurrencyBase.defaultProps,
    }

    static get TYPES() {
        return CURRENCY_TYPES
    }

    render() {
        switch (this.props.type) {
            case CURRENCY_TYPES.GOLD:
                return <Gold {...this.props} />

            case CURRENCY_TYPES.SILVER:
                return <Silver {...this.props} />

            case CURRENCY_TYPES.BONS:
                return <Bons {...this.props} />

            case CURRENCY_TYPES.EVENT_COIN:
                return <EventCoin {...this.props} />
            default:
                return null
        }
    }
}

export default Currency



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Currency/Currency.jsx